import { watch } from 'vue'
import { useOidcAuth } from '#imports'
import { useExperimentalFeatures } from '~/composables/experimental/useExperimentalFeatures'

/**
 * Charge les features expérimentales de l’utilisateur connecté.
 * Tant que la réponse n’est pas là, ou si l’appel échoue, elles restent masquées.
 */
export default defineNuxtPlugin(() => {
  const { loggedIn } = useOidcAuth()
  const { refresh, reset } = useExperimentalFeatures()

  watch(
    loggedIn,
    (isLoggedIn) => {
      if (!isLoggedIn) {
        reset()
        return
      }
      void refresh()
    },
    { immediate: true },
  )
})
